var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-main",style:({ backgroundImage: _vm.pageBgImage })},[(_vm.$TestApp.getPageCurrent() !== 1)?_c('Header'):_vm._e(),_c(_vm.pageComp,{tag:"component"}),(_vm.$TestApp.getPageCurrent() !== 1)?_c('div',{staticClass:"cloudy-pg1"},[_c('img',{attrs:{"src":require("@/assets/cloudy.png")}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }